<!--
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
-->
<template>
  <div
    ref="svgContainer"
    class="common-icon"
    :class="type"
    :style="styles"
    @click="e => $emit('click', e)"
  ></div>
</template>

<script>
import { getCurrentInstance, nextTick } from 'vue'
import icons from './index'

function generateSvgElement(icon) {
  function createSvgElement(tag, attrs) {
    const element = document.createElementNS('http://www.w3.org/2000/svg', tag)
    element.setAttribute('width', '1em') // 默认antd大小
    element.setAttribute('height', '1em') // 默认antd大小
    element.setAttribute('fill', 'currentColor') // 默认antd大小
    for (const key in attrs) {
      element.setAttribute(key, attrs[key])
    }
    return element
  }

  function buildSvgElement(node) {
    const element = createSvgElement(node.tag, node.attrs)
    if (node.children) {
      node.children.forEach(childNode => {
        element.appendChild(buildSvgElement(childNode))
      })
    }
    return element
  }

  return buildSvgElement(icon.icon)
}

export default {
  props: {
    type: {
      type: String,
      requied: false,
    },
    styles: {
      type: Object,
      requied: false,
    },
  },
  setup(props) {
    const vm = getCurrentInstance()
    nextTick(() => {
      const svgElement = generateSvgElement(icons[props.type])
      vm.proxy.$refs.svgContainer.appendChild(svgElement)
    })
  },
}
</script>
